import React, { PureComponent } from 'react';
import bindAll from 'lodash.bindall';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import event, { EVENTS } from '../../lib/event.js';
import styles from './style.css';
import ChatCards from './chat-cards'

class ChatBody extends PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            // 'onDrag',
            // 'handleStop',
            // 'showTips'
        ]);
    }

    // componentDidMount() {
    //     event.on('NO_TALK', this.noSpeak)
    //     event.on('SPEAKING', this.good)
    // }

    // componentWillReceiveProps(nextProps) {
    //     console.log(nextProps)
    // }


    render() {
        const { chatList, mode } = this.props;
        return (
            <div className={styles.chatList} id='chatList'>
                {
                    chatList.map((item, i) => (
                        <div className={styles.step} key={item.stepIndex}>
                            <div className={styles.stepLine}>
                                <span>STEP {i+1}</span>
                                <p></p>
                            </div>
                            <ChatCards step={item} stepLast={i === chatList.length - 1 ? true : false} mode={mode} />
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ChatBody;
